import {
    GET_LEADS_AFFILIATE,
    GET_LEADS_AFFILIATE_SUCCESS,
    GET_LEADS_AFFILIATE_FAILURE,
} from '../constants/get_leads_affiliate.constants';

export const getLeadsAffiliateRequest = () => ({
    type: GET_LEADS_AFFILIATE,
});

export const getLeadsAffiliateSuccess = leadsAffiliate => ({
    type: GET_LEADS_AFFILIATE_SUCCESS,
    leadsAffiliate,
});

export const getLeadsAffiliateFailure = error => ({
    type: GET_LEADS_AFFILIATE_FAILURE,
    error,
});



// WEBPACK FOOTER //
// ./src/modules/Leads/Manage_retail/redux/actions/get_leads_affiliate.actions.js